module.exports = __webpack_public_path__ + "img/infraestructura-services.4a89f642.jpg";